import React from "react";
import commonStyles from "../../../containers/settings/settingsEditCommon.css";
import { TripleDatePickerWithLabel } from "../../settings/users/components/adviserEditScreen/tripleDatePickerWithLabel/tripleDatePickerWithLabel";
import { intl } from "@fidget/common/i18n/TypedIntl";
import { useTimeValidityController } from "./useTimeValidityController";
import { staticConfig } from "@fidget/common/config/static-config";

interface Props {
  controller: ReturnType<typeof useTimeValidityController>;
  validFrom: number | undefined;
  validTo: number | undefined;
}

export const TimeValidityRangePicker = ({ controller, validFrom, validTo }: Props) => {
  return (
    <div className={commonStyles.content}>
      <TripleDatePickerWithLabel
        ref={(e) => (controller.fromInputRef.current = e || undefined)}
        onDatePicked={controller.handleDatePick("from")}
        handleClear={controller.handleFieldClear("from")}
        additionalValidation={controller.validateBottomRange}
        initialChoice={controller.convertUnixDateToChoice(validFrom)}
        label={intl.formatMessage("settings.advisers.edit.validity.from")}
        yearsAscending
      />

      <TripleDatePickerWithLabel
        datum={controller.datum}
        ref={(e) => (controller.toInputRef.current = e || undefined)}
        onDatePicked={controller.handleDatePick("to")}
        handleClear={controller.handleFieldClear("to")}
        additionalValidation={controller.validateUpperRange}
        yearsAhead={staticConfig.yearsAheadValidityPickerUpperRange}
        initialChoice={controller.convertUnixDateToChoice(validTo)}
        yearsBackward={staticConfig.yearsBackwardValidityPickerUpperRange}
        label={intl.formatMessage("settings.advisers.edit.validity.to")}
        yearsAscending
      />
    </div>
  );
};
